/**
 * @file paymentMeans.js
 * @description Pure helpers for ZATCA payment means codes.
 * No React. No state. No side effects. Easy to unit test.
 */

/**
 * Map a UI payment-mode label to its ZATCA payment-means code.
 *
 * Throws if mode is empty or unknown — callers must validate upstream
 * (handleSaveAsDraft / handleIssue) and surface a clear error to the user
 * BEFORE building the payload. Silent defaulting to "Bank Deposit" caused
 * misleading ZATCA errors when the user forgot to pick a method.
 *
 * @param {string} mode
 * @returns {string} ZATCA code
 * @throws {Error} when mode is empty or unrecognised
 */
export const getPaymentMeansCode = (mode) => {
  switch (mode) {
    case "Cash":
      return "10";
    case "Cheque":
    case "Demand Draft":
      return "20";
    case "Credit Card":
    case "Debit Card":
      return "48";
    case "Bank Deposit":
    case "Online Transfer":
    case "Wire Transfer":
      return "30";
    case "Online Payment Gateway":
    case "PayPal":
      return "68";
    default:
      throw new Error("Please select a payment method");
  }
};

/**
 * Whether the payment mode is a bank-account-based payment
 * (and therefore requires an IBAN in the payload).
 * @param {string} mode
 * @returns {boolean}
 */
export const isBankPayment = (mode) =>
  ["Bank Deposit", "Online Transfer", "Wire Transfer"].includes(mode);